import React from 'react';
import CrearEquipos from '../../../components/insumos/equipos/CrearEquipos';

const EquiposPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Crear Equipos</h1>
      <br />
      <br />
      <CrearEquipos />
    </div>
  );
};

export default EquiposPage;